import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import DirectSupport from "./sections/DirectSupport";
import InTheNeighborhood from "./sections/InTheNeighborhood";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <DirectSupport />
      <InTheNeighborhood />
      <Footer />
    </div>;
}